import { render, staticRenderFns } from "./NoteTableData.vue?vue&type=template&id=138bafdd&"
import script from "./NoteTableData.vue?vue&type=script&lang=js&"
export * from "./NoteTableData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports